import '@naturehouse/design-system/components/atoms/carousel-indicators/CarouselIndicators';
import '@naturehouse/design-system/components/atoms/date-field/DateField';
import '@naturehouse/design-system/components/atoms/range-slider/RangeSlider';
import '@naturehouse/design-system/components/molecules/calendar-week-days/CalendarWeekDays';
import '@naturehouse/design-system/components/molecules/slides-carousel/SlidesCarousel';
import '@naturehouse/design-system/components/molecules/tabs/Tabs';
import '@naturehouse/design-system/components/organisms/image-carousel/ImageCarousel';
import instantiateSimpleCarousel from '@naturehouse/design-system/components/molecules/carousel/simple-carousel/simple-carousel';
import GoogleAnalyticsEvents from '../../common/GoogleAnalyticsEvents';
import '../../common/search/ScrollToTopHouseSearch';
import '../../common/search/InstantiateSwiperInstances';
import PaginationFilter from '../../common/search/store/PaginationFilter';
import DomEvents from '../../events/domEvents';
import Curtain from '../../ui/Curtain';
import '../../ui/web-components/searchBar/DestinationSearch';
import '../../ui/web-components/searchBar/SearchBar';
import '../calendar/webComponents/CalendarInput';
import '../calendar/webComponents/DatePickerCalendar';
import Module from '../module';
import './PaginationHandler';
import AggregationComponent from './components/AggregationComponent';
import './components/FlexibleHouseCarousel';
import './components/PaginationRenderer';
import PriceRange from './components/PriceRange';
import SearchFiltersModal from './components/SearchFiltersModal';
import SearchFormComponent from './components/SearchFormComponent';
import SearchMap from './components/SearchMap';
import SearchMapFiltersModal from './components/SearchMapFiltersModal';
import SearchMapModal from './components/SearchMapModal';
import SearchResults from './components/SearchResults';
import SelectedFilters from './components/SelectedFilters';
import HousePricingApi from './store/HousePricingApi';
import HouseSearchApi from './store/HouseSearchApi';
import HouseSearchFilters from './store/HouseSearchFilters';
import SearchUrlUpdaterFactory from './store/SearchUrlUpdaterFactory';
import ArrivalDepartureToPriceConnector from './storeConnectors/ArrivalDepartureToPriceConnector';
import BedroomsConnector from './storeConnectors/BedroomsConnector';
import DestinationSearchConnector from './storeConnectors/DestinationSearchConnector';
import FlexibleArrivalDateConnector from './storeConnectors/FlexibleArrivalDateConnector';
import FlexibleStayConnector from './storeConnectors/FlexibleStayConnector';
import GeoRadiusConnector from './storeConnectors/GeoRadiusConnector';
import SearchMapToLimitFilterConnector from './storeConnectors/SearchMapToLimitFilterConnector';
import StayDurationToFlexibleArrivalConnector from './storeConnectors/StayDurationToFlexibleArrivalConnector';
import StayDurationTypeToArrivalDepartureConnector from './storeConnectors/StayDurationTypeToArrivalDepartureConnector';
import TravelPartyConnector from './storeConnectors/TravelPartyConnector';
import './webComponents/ResetSearchFilterButton';
import './webComponents/RetrySearchButton';
import '../../../css/views/search.pcss';

export default class SearchModule extends Module {
    constructor() {
        super();

        instantiateSimpleCarousel();
        this.components.push(SearchFormComponent);
        this.components.push(SearchResults);
        this.components.push(AggregationComponent);
        this.components.push(SelectedFilters);
        this.components.push(Curtain);
        this.components.push(PriceRange);
        this.components.push(SearchMapModal);
        this.components.push(SearchMapFiltersModal);
        this.components.push(SearchFiltersModal);
        this.components.push(SearchMap);
    }

    public init(): void {
        super.init();

        GoogleAnalyticsEvents.searchImpression();

        document.querySelector('nh-carousel-indicators')?.addEventListener('click', (ev) => {
            ev.stopPropagation();
        });

        this.#connectElements();
    }

    #connectElements(): void {
        const filters = HouseSearchFilters.getInstance();
        HouseSearchApi.getInstance();
        HousePricingApi.getInstance();

        const urlUpdater = SearchUrlUpdaterFactory.create();

        TravelPartyConnector.connectToElement('nh-travel-company');
        ArrivalDepartureToPriceConnector.connect();
        BedroomsConnector.connectToElement('#search_bedrooms');
        DestinationSearchConnector.connectToElement('nh-destination-search', urlUpdater);
        FlexibleArrivalDateConnector.connectToElement('#flexibleArrivalDate');
        StayDurationTypeToArrivalDepartureConnector.connect();
        StayDurationToFlexibleArrivalConnector.connect();
        FlexibleStayConnector.connectToElements(
            'nh-stay-duration [name="flexibleDurationType"]',
            'nh-stay-duration [name="flexibleBookingMonths"]'
        );
        GeoRadiusConnector.connectToElement('.search__geo-radius nh-range-slider');

        const paginationFilter = filters.get(PaginationFilter.NAME) as PaginationFilter;
        SearchMapToLimitFilterConnector.connect(paginationFilter);

        document.addEventListener(DomEvents.templateInstantiated, (event) => {
            const detail = event.detail;

            if (detail && detail.id === 'modal_mobile_aggregations') {
                BedroomsConnector.connectToElement(
                    '#modal_mobile_aggregations select[name="bedrooms"]'
                );
                GeoRadiusConnector.connectToElement(
                    '#modal_mobile_aggregations .search__geo-radius nh-range-slider'
                );
            }
        });
    }
}

(function searchInit(): void {
    const searchModule: SearchModule = new SearchModule();
    searchModule.init();
})();
